module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./TankLevel.js"));
	}, "TankLevel");
}